// ============================================================
// USPATIH GO — Alpine Store: Notifications (bell + badge + sound)
// ============================================================

import Alpine from 'alpinejs';
import axios from '../config/axios.js';
import { API_BASE } from '../config/axios.js';
import {
  loadNotificationSoundPrefs,
  playNotificationSound,
} from '../utils/notificationSound.js';
import { resolveNotificationWebUrl } from '../utils/resolveNotificationWebUrl.js';

Alpine.store('notifications', {
  unread: 0,
  items: [],
  loading: false,
  open: false,
  _prevUnread: 0,
  _prefsReady: false,

  async ensureSoundPrefs() {
    if (this._prefsReady) return;
    await loadNotificationSoundPrefs();
    this._prefsReady = true;
  },

  async fetchUnread() {
    if (!Alpine.store('auth').isLoggedIn) return;
    try {
      await this.ensureSoundPrefs();
      const { data } = await axios.get(`${API_BASE}/notifications/unread-count`);
      const next = data.data?.count || 0;
      if (next > this._prevUnread && this._prevUnread > 0) {
        playNotificationSound();
        void this.showPopupIfNeeded();
      }
      this._prevUnread = next;
      this.unread = next;
    } catch { /* silent */ }
  },

  async showPopupIfNeeded() {
    try {
      const { data } = await axios.get(`${API_BASE}/notifications`, { params: { per_page: 3, is_read: 'false' } });
      const items = data.data || [];
      const popup = items.find((n) => n.data?.popup || n.type === 'spk_workflow');
      if (popup) {
        window.toast?.(popup.message || popup.title, 'info', { duration: 8000 });
      }
    } catch { /* silent */ }
  },

  async fetchRecent(limit = 8) {
    if (!Alpine.store('auth').isLoggedIn) return;
    this.loading = true;
    try {
      const { data } = await axios.get(`${API_BASE}/notifications`, {
        params: { per_page: limit },
      });
      this.items = data.data || [];
      this.unread = data.unread_count ?? this.unread;
    } catch { /* silent */ }
    finally { this.loading = false; }
  },

  async toggle() {
    this.open = !this.open;
    if (this.open) await this.fetchRecent();
  },

  close() { this.open = false; },

  async markRead(id) {
    try {
      await axios.post(`${API_BASE}/notifications/${id}/read`);
      const item = this.items.find((n) => n.id === id);
      if (item && !item.is_read) {
        item.is_read = true;
        this.unread = Math.max(0, this.unread - 1);
      }
    } catch { /* silent */ }
  },

  async markAllRead() {
    try {
      await axios.post(`${API_BASE}/notifications/read-all`);
      this.items.forEach((n) => { n.is_read = true; });
      this.unread = 0;
    } catch { /* silent */ }
  },

  go(item) {
    if (!item) return;
    if (!item.is_read) this.markRead(item.id);
    this.close();
    const href = resolveNotificationWebUrl(item);
    if (href) window.location.href = href;
  },
});

if (typeof window !== 'undefined') {
  document.addEventListener('alpine:init', () => {
    setInterval(() => {
      if (Alpine.store('auth').isLoggedIn) {
        Alpine.store('notifications').fetchUnread();
      }
    }, 120_000);
  });
}
